import { gql } from '@apollo/client';
import { ContactFragment } from '../fragments/ContactFragment';
/**
 * @const ContactQuery
 * @since 1.0.0
 */
export const ContactQuery = gql `
  query ContactQuery($input: ContactInput!) {
    contact(input: $input) {
      ...ContactFragment
    }
  }

  ${ContactFragment}
`;
